module.exports = __webpack_public_path__ + "assets/f817a7365fade34404b96dbcb7f0f0cf.mp3";